// extracted by mini-css-extract-plugin
export default {"framework-selector":"Q_b1 d-flex","framework-selector__icon":"Q_b2","framework-selector__option":"Q_b3 p-2 flex-grow-1 ml-2","framework-selector__option--selected":"Q_b4"};